import { render } from "./SerialModal.vue?vue&type=template&id=66ba7c60&scoped=true"
import script from "./SerialModal.vue?vue&type=script&lang=js"
export * from "./SerialModal.vue?vue&type=script&lang=js"

import "./SerialModal.vue?vue&type=style&index=0&id=66ba7c60&lang=scss&scoped=true"

import exportComponent from "F:\\work\\1\\s\\vue-code\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66ba7c60"]])

export default __exports__